define(["data/config"], function(config) {
    var apply = function($element, params) {
        var autoClickInterval, autoClickTimeout;

        $element.on("mouseout", function() {
            try {
                clearTimeout(autoClickTimeout);
            } catch (e) {}
            try {
                clearInterval(autoClickInterval);
            } catch (e) {}
        });

        $element.on(
            "mousedown",
            "." + config.prefixes.component + "uiInputStepper-step--up",
            function() {
                $element.trigger(config.events.uiInputStepperUp);
                autoClickTimeout = setTimeout(function() {
                    autoClickInterval = setInterval(function() {
                        $element.trigger(config.events.uiInputStepperUp);
                    }, 50);
                }, 100);
                $element.one(
                    "mouseup",
                    "." + config.prefixes.component + "uiInputStepper-step--up",
                    function() {
                        $element.trigger("mouseout");
                    }
                );
            }
        );
        $element.on(
            "mousedown",
            "." + config.prefixes.component + "uiInputStepper-step--down",
            function() {
                $element.trigger(config.events.uiInputStepperDown);
                autoClickTimeout = setTimeout(function() {
                    autoClickInterval = setInterval(function() {
                        $element.trigger(config.events.uiInputStepperDown);
                    }, 50);
                }, 100);
                $element.one(
                    "mouseup",
                    "." +
                        config.prefixes.component +
                        "uiInputStepper-step--down",
                    function() {
                        $element.trigger("mouseout");
                    }
                );
            }
        );
    };

    return {
        name: "uiInputStepper",
        apply: apply
    };
});
